<template>
  <button
    type="button"
    role="switch"
    :aria-checked="active"
    :title="active ? 'Désactiver' : 'Activer'"
    class="relative inline-flex h-8 w-[52px] shrink-0 items-center rounded-full transition-colors duration-200 disabled:opacity-50"
    :class="active ? 'bg-[#34c759]' : 'bg-[#e9e9eb]'"
    :disabled="disabled"
    @click.stop="emit('toggle')"
  >
    <span
      class="inline-block h-7 w-7 rounded-full bg-white shadow-[0_1px_2px_rgba(0,0,0,0.2)] transition-transform duration-200"
      :class="active ? 'translate-x-[22px]' : 'translate-x-0.5'"
    />
  </button>
</template>

<script setup lang="ts">
defineProps<{ active: boolean; disabled?: boolean }>();
const emit = defineEmits<{ toggle: [] }>();
</script>
